import axios from "axios";
const base = () => `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/executive-director`;
const get = async p => (await axios.get(`${base()}${p}`)).data;
const patch = async (p,d) => (await axios.patch(`${base()}${p}`,d)).data;
const post = async (p,d) => (await axios.post(`${base()}${p}`,d)).data;
export const getEDDashboard = id => get(`/staff/${id}/dashboard`);
export const getEDSDDs = id => get(`/staff/${id}/sdds`);
export const getEDFDCs = id => get(`/staff/${id}/fdcs`);
export const getEDClients = id => get(`/staff/${id}/clients`);
export const getEDWallet = id => get(`/staff/${id}/wallet`);
export const getEDProfile = id => get(`/staff/${id}/profile`);
export const updateEDProfile = (id,d) => patch(`/staff/${id}/profile`,d);
export const getEDSettings = id => get(`/staff/${id}/settings`);
export const updateEDSettings = (id,d) => patch(`/staff/${id}/settings`,d);
export const performStaffAction = (id,d) => post(`/staff/${id}/staff-action`,d);
export const createDisciplinaryCase = (id,d) => post(`/staff/${id}/discipline`,d);
export const requestWithdrawal = (id,d) => post(`/staff/${id}/wallet/withdraw`,d);

export const registerFDCByED = (id,d) => post(`/staff/${id}/fdcs/register`,d);
// Regional executive dashboard reminders are saved in a separate, ED-scoped collection.
export const getEDReminders = id => get(`/staff/${id}/reminders`);
export const createEDReminder = (id, data) => post(`/staff/${id}/reminders`, data);

export const logoutED = id => post(`/staff/${id}/logout`, {});
